import { styled, Box } from '@mui/material';

export const MuiLinkButtonContainer = styled(Box)(() => ({
  '& a:hover': {
    opacity: '1 !important',
  },
}));
